import {Cureus} from '../Cureus';

Cureus.MediaLibrary = {
  Edit: {},
  New: {},
  Details: {}
};

//= require_tree ./MediaLibrary
